export enum MaterialView {
	CATALOGS = 0, //list of catalogs
	CATALOG_MATERIALS = 1, //tree of materials per catalog with view to edit
	MATERIAL_PROPERTIES = 2,
	MATERIAL_SUBSTITUTES
}
